export enum OfferGroupSortCriteria {
  QUALIFYING_PRICE = 'QUALIFYING_PRICE',
  AVERAGE_OFFER_PRICE = 'AVERAGE_OFFER_PRICE',
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/model/offer-group-sort-criteria.ts